module.exports = __webpack_public_path__ + "static/Susfinteq-9bfc8c319c946d62dc7d83ccb9dbe6cb.jpg";